// extracted by mini-css-extract-plugin
export default {"wrapperTimer":"Timer_wrapperTimer__NI9xo","time":"Timer_time__CN6e9"};